export default {
    companyName: {
        required: true
    },
    companyOrgNo: {
        required: true,
        organisation_number: true
    },
    companyStreet: {
        required: true
    },
    companyPostalCode: {
        required: true,
        postal_code: true
    },
    companyCity: {
        required: true,
        maxlength: 30
    },
}